import styles from "css/input/InputWithQuestionAndLabel.module.css";
import Body1 from "components/text/Body1";
import Body2 from "components/text/Body2";
import ColorClass from "types/enums/ColorClass";

type Props = {
  children: any;
  label?: string | JSX.Element;
  question?: string | JSX.Element;
};

export default function InputWithQuestionAndLabel({
  children,
  label,
  question,
}: Props): JSX.Element {
  return (
    <div className={styles.container}>
      {question != null && (
        <Body1
          className={styles.question}
          colorClass={ColorClass.Primary}
          textAlign="left"
        >
          {question}
        </Body1>
      )}
      {label != null && (
        <Body2
          className={styles.label}
          colorClass={ColorClass.Secondary}
          textAlign="left"
        >
          {label}
        </Body2>
      )}
      <div className={styles.input}>{children}</div>
    </div>
  );
}
